import type { AppProps } from "next/app";
import Head from "next/head";
import "../styles/globals.css";
import Layout from "../components/Layout";
import GoogleAnalytics from "../components/GoogleAnalytics";

const siteUrl = (process.env.NEXT_PUBLIC_SITE_URL ?? "https://www.kmcpaccounting.com").replace(/\/$/, "");
const organizationSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: "KMCP Accounting",
      alternateName: "KMCP Accounting Chiang Mai",
      inLanguage: "th-TH",
      publisher: { "@id": `${siteUrl}/#organization` }
    },
    {
      "@type": "AccountingService",
      "@id": `${siteUrl}/#organization`,
      name: "KMCP Accounting",
      url: `${siteUrl}/`,
      image: `${siteUrl}/images/hero-cover.jpg`,
      logo: {
        "@type": "ImageObject",
        url: `${siteUrl}/KMCP-1024x1024.png`,
        width: 1024,
        height: 1024
      },
      telephone: "+66-82-254-6831",
      email: "kmcp.acc@gmail.com",
      priceRange: "฿฿",
      areaServed: { "@type": "AdministrativeArea", name: "เชียงใหม่" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "120/36 หมู่ 3 ตำบลดอนแก้ว",
        addressLocality: "อำเภอแม่ริม",
        addressRegion: "เชียงใหม่",
        postalCode: "50180",
        addressCountry: "TH"
      },
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        telephone: "+66-82-254-6831",
        email: "kmcp.acc@gmail.com",
        areaServed: "TH",
        availableLanguage: ["th", "en"]
      },
      sameAs: [
        "https://www.facebook.com/kmcp.acc",
        "https://line.me/R/ti/p/@kmcp.acc"
      ]
    }
  ]
};

export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#f4cf21" />
        <link rel="icon" href="/KMCP-Favicon-03.png" />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      </Head>
      <GoogleAnalytics />
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </>
  );
}
